<template>
    <div>
        <template v-if="getExtras().length">

            <pm-pdf-jaw-header
                :title="$t('plan_calculator.extras')"
                :price="fullTotal"
            />

            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                <template v-for="(option, key) in getExtras()" v-if="option.amount > 0">

                    <pm-pdf-treatment-step-percentage v-if="option.isPercentage"
                        :title="getTitle(option)"
                        :amount="option.amount"
                        :unit-price="Math.round(($store.state.simplePlan.upperJawTotal + $store.state.simplePlan.lowerJawTotal) * (option.amount / 100))"
                    />

                    <pm-pdf-treatment-step v-else
                        :title="getTitle(option)"
                        :amount="option.amount"
                        :unit-price="option.unit_price"
                        :tooth-ids="option.toothIds ? option.toothIds : []"
                    />

                </template>
            </table>
            <br/>
        </template>
    </div>
</template>

<script>
    import PmExtrasOverview from "./extras-overview";
    import PmPdfTreatmentStep from "../pdf/treatment-step.vue";
    import PmPdfTreatmentStepPercentage from "../pdf/treatment-step-percentage.vue";
    import PmPdfJawHeader from "../pdf/jaw-header.vue";
    export default {
        extends: PmExtrasOverview,
        components: {
            PmPdfTreatmentStep,
            PmPdfTreatmentStepPercentage,
            PmPdfJawHeader,
        }
    }
</script>
